import { render, staticRenderFns } from "./DisplayLayoutTable.vue?vue&type=template&id=0bd67976"
import script from "./DisplayLayoutTable.vue?vue&type=script&lang=js"
export * from "./DisplayLayoutTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports